import { FC, memo } from 'react'
import { CompanyCard } from '@leadgen/models/client'
import { useSelector } from '../../../../redux/hooks'
import companySelectors from '../../../../redux/modules/company/selectors'
import { CompanyCardRow as BaseCompanyCardRow } from '../CompanyCardRow'
import { CompanyCardMenu } from '../CompanyCardMenu'

const CompanyCardRow: FC<{ companyCard: CompanyCard }> = ({ companyCard }) => {
  const defaultStripePaymentMethodId = useSelector(companySelectors.getStripePaymentMethodId)
  const isDefaultCard = defaultStripePaymentMethodId === companyCard.id

  return (
    <BaseCompanyCardRow
      companyCard={companyCard}
      isDefaultCard={isDefaultCard}
      menuElement={<CompanyCardMenu companyCard={companyCard} enableDelete enableSwitch />}
    />
  )
}

export default memo(CompanyCardRow)
